(() => {
  const makeRequestKey = () => {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  };

  const valueOf = (form, name) => form.elements.namedItem(name)?.value?.trim() || '';
  const numericId = (value) => /^\d+$/.test(String(value || '')) ? String(value) : '';

  document.querySelectorAll('[data-b2b-form]').forEach((form) => {
    const section = form.closest('[data-rdr21-b2b-section]');
    const productInput = form.querySelector('[data-b2b-product-search-input]');
    const productResults = form.querySelector('[data-b2b-product-results]');
    const searchStatus = form.querySelector('[data-b2b-search-status]');
    const marketingConsent = form.elements.namedItem('marketing_consent');
    const newsletterForm = section?.querySelector('[data-b2b-marketing-form]');
    const newsletterEmail = newsletterForm?.querySelector('[data-b2b-marketing-email]');
    const newsletterSuccess = form.querySelector('[data-b2b-marketing-success]')?.textContent?.trim() || '';
    const newsletterFailure = form.querySelector('[data-b2b-marketing-failure]')?.textContent?.trim() || '';
    const variantSelect = form.querySelector('[data-b2b-variant-select]');
    const productIdInput = form.querySelector('[data-b2b-product-id]');
    const variantIdInput = form.querySelector('[data-b2b-variant-id]');
    const productTitle = form.querySelector('[data-b2b-product-title]');
    const variantTitle = form.querySelector('[data-b2b-variant-title]');
    const status = form.querySelector('[data-b2b-status]');
    const unavailable = section?.querySelector('[data-b2b-unavailable]');
    const submit = form.querySelector('[data-b2b-submit]');
    let requestKey = '';
    let lastPayload = '';
    let submitted = false;
    let searchTimer;
    let searchController;
    let variantController;
    let loadProductVariants;
    let selectedProductHandle = '';
    let manuallySelectedProduct = false;
    let pageSelectedHandle = productInput?.dataset.initialProductHandle || '';

    const setStatus = (message, kind = '') => {
      if (!status) return;
      status.textContent = message;
      if (kind) status.dataset.kind = kind;
      else delete status.dataset.kind;
    };

    const submitNewsletterConsent = async (email) => {
      if (!marketingConsent?.checked || !newsletterForm || !newsletterEmail) return '';
      newsletterEmail.value = email;
      const response = await fetch(newsletterForm.action || window.location.pathname, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
        body: new FormData(newsletterForm),
      });
      const responseText = await response.text();
      const responseUrl = new URL(response.url || window.location.href, window.location.origin);
      const documentResult = new DOMParser().parseFromString(responseText, 'text/html');
      const hasSuccessMarker = Boolean(documentResult.querySelector('.form__message--success, [data-form-status="success"], .newsletter-form__message--success'));
      const confirmedByShopify = responseUrl.searchParams.get('customer_posted') === 'true'
        || responseUrl.searchParams.get('contact_posted') === 'true'
        || /customer_posted=true|contact_posted=true/.test(responseText)
        || hasSuccessMarker;
      return response.ok && confirmedByShopify ? newsletterSuccess : newsletterFailure;
    };

    const productForm = document.querySelector('.rdr21-product-form form');
    const syncFromProductPage = (event) => {
      if (!productForm || manuallySelectedProduct) return;
      const pageProduct = event?.detail?.product || null;
      const productId = numericId(pageProduct?.id || productForm.querySelector('input[name="product-id"]')?.value || productIdInput?.value);
      const variantControl = productForm.querySelector('[data-family-variant-id], [data-autodesk-variant-id], [data-corel-variant-id], select[data-product-variants], select[data-corel-platform], input[name="id"]');
      const variantId = numericId(variantControl?.value);
      if (pageProduct?.handle) pageSelectedHandle = pageProduct.handle;
      const handle = pageSelectedHandle;
      const title = pageProduct?.title || productInput?.value || productInput?.dataset.initialProductTitle || document.querySelector('.rdr21-product-info h1')?.textContent?.trim() || '';
      const existingProductId = numericId(productIdInput?.value);
      if (!pageProduct && productId && existingProductId && productId !== existingProductId) return;
      const productChanged = handle && productId && (selectedProductHandle !== handle || numericId(productIdInput?.value) !== productId);
      if (productId && productIdInput) productIdInput.value = productId;
      if (handle && title && productInput) productInput.value = title;
      if (productChanged) {
        selectedProductHandle = handle;
        loadProductVariants(handle, productId, variantId);
      } else if (variantId && variantSelect) {
        const matchingOption = [...variantSelect.options].find((option) => numericId(option.value) === variantId);
        if (matchingOption) {
          variantSelect.value = matchingOption.value;
          if (variantIdInput) variantIdInput.value = variantId;
          if (variantTitle) variantTitle.textContent = matchingOption.textContent.trim();
        }
      }
      const heading = document.querySelector('.rdr21-product-info h1');
      if (heading && productTitle) productTitle.textContent = heading.textContent.trim();
      let selectedLabel = '';
      if (variantControl instanceof HTMLSelectElement) selectedLabel = variantControl.selectedOptions[0]?.textContent?.trim() || '';
      if (variantControl?.matches('[data-family-variant-id]')) {
        const selectedFamilyLabel = productForm.querySelector('[data-family-picker] .rdr21-family-option.is-selected strong')?.textContent?.trim();
        const selectedServerYear = productForm.querySelector('[data-family-picker] [data-family-server-year][aria-pressed="true"] strong')?.textContent?.trim();
        const selectedServerType = productForm.querySelector('[data-family-picker] [data-family-server-type][aria-pressed="true"] strong')?.textContent?.trim();
        selectedLabel = selectedFamilyLabel || [selectedServerYear, selectedServerType].filter(Boolean).join(' · ');
      }
      if (variantControl?.matches('[data-autodesk-variant-id]')) {
        selectedLabel = productForm.querySelector('input[name="rdr21-autodesk-edition"]:checked')?.closest('[data-autodesk-option]')?.querySelector('strong')?.textContent?.trim() || '';
      }
      if (variantControl?.matches('[data-corel-variant-id]')) {
        selectedLabel = productForm.querySelector('[data-corel-years] .rdr21-autodesk-year.is-selected strong')?.textContent?.trim() || productForm.querySelector('[data-corel-platform] option:checked')?.textContent?.trim() || '';
      }
      if (selectedLabel && variantTitle) variantTitle.textContent = selectedLabel;
    };

    if (productInput && productResults && variantSelect) {
      productInput.addEventListener('focus', () => {
        if (numericId(productIdInput?.value) && productInput.value) productInput.select();
      });
      const closeSuggestions = () => {
        productResults.hidden = true;
        productInput.setAttribute('aria-expanded', 'false');
      };
      const announceSearch = (message) => { if (searchStatus) searchStatus.textContent = message || ''; };
      const excludedProduct = (item) => {
        const handle = (item.dataset.productHandle || '').toLowerCase();
        const type = (item.dataset.productType || '').toLowerCase();
        return ['-billiger-de', '-guenstiger-de', '-geizhals-de', '-pepita-de', '-heureka-sk'].some((suffix) => handle.endsWith(suffix))
          || handle.includes('bundle') || handle.includes('paket') || type.includes('bundle') || type.includes('paket');
      };
      const resetSelection = () => {
        productIdInput.value = '';
        variantIdInput.value = '';
        selectedProductHandle = '';
        variantController?.abort();
        variantSelect.replaceChildren(new Option(form.dataset.variantPlaceholder || '', ''));
        variantSelect.disabled = true;
      };
      loadProductVariants = async (handle, expectedId, preferredVariantId = '') => {
        setStatus(form.dataset.loadingVariants || '');
        variantController?.abort();
        variantController = new AbortController();
        variantSelect.replaceChildren(new Option(form.dataset.variantPlaceholder || '', ''));
        variantSelect.disabled = true;
        variantIdInput.value = '';
        try {
          const url = new URL(`/products/${encodeURIComponent(handle)}.js`, window.location.origin);
          const response = await fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin', signal: variantController.signal });
          if (!response.ok) throw new Error('Product data unavailable');
          const data = await response.json();
          if (String(data.id) !== expectedId || data.handle !== handle || !Array.isArray(data.variants)) throw new Error('Product mismatch');
          if (selectedProductHandle !== handle || numericId(productIdInput.value) !== expectedId) return;
          const seenVariantIds = new Set();
          const availableVariants = data.variants.filter((variant) => {
            const id = numericId(variant.id);
            if (!variant.available || !id || seenVariantIds.has(id)) return false;
            seenVariantIds.add(id);
            return true;
          });
          availableVariants.forEach((variant) => {
            const title = variant.public_title || variant.title;
            const isAutodeskEducation = data.handle.includes('autodesk') && /education/i.test(title);
            const hasExplicitDuration = /\b(?:1|3)\s*(?:years?|jahre|roky)\b|\b(?:12|36)\s*months?\b/i.test(title);
            const displayTitle = isAutodeskEducation && !hasExplicitDuration
              ? `${title} — ${form.dataset.autodeskOneYearLabel || '1 Jahr'}`
              : title;
            const item = new Option(`${displayTitle} — ${new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: data.currency || 'EUR' }).format(variant.price / 100)}`, String(variant.id));
            variantSelect.add(item);
          });
          if (!availableVariants.length) throw new Error('No available variants');
          variantSelect.disabled = false;
          const preferredIndex = availableVariants.findIndex((variant) => String(variant.id) === String(preferredVariantId));
          variantSelect.selectedIndex = preferredIndex >= 0 ? preferredIndex + 1 : 1;
          variantIdInput.value = numericId(variantSelect.value);
          if (variantTitle) variantTitle.textContent = variantSelect.selectedOptions[0]?.textContent?.trim() || '';
          setStatus('');
        } catch (error) {
          if (error.name === 'AbortError') return;
          productIdInput.value = '';
          variantIdInput.value = '';
          variantSelect.replaceChildren(new Option(form.dataset.noVariants || '', ''));
          setStatus(form.dataset.errorGeneral || '', 'error');
        }
      };
      const chooseProduct = (item) => {
        const handle = item.dataset.productHandle || '';
        const expectedId = numericId(item.dataset.productId);
        if (!handle || !expectedId || excludedProduct(item)) return;
        manuallySelectedProduct = true;
        productInput.value = item.querySelector('.rdr21-search-result__title')?.textContent?.trim() || item.textContent.trim();
        selectedProductHandle = handle;
        productIdInput.value = expectedId;
        variantIdInput.value = '';
        variantSelect.replaceChildren(new Option(form.dataset.variantPlaceholder || '', ''));
        variantSelect.disabled = true;
        productResults.replaceChildren();
        closeSuggestions();
        announceSearch('');
        loadProductVariants(handle, expectedId);
      };
      const searchProducts = async (term) => {
        const url = new URL(productInput.dataset.endpoint, window.location.origin);
        url.searchParams.set('q', term);
        url.searchParams.set('section_id', 'predictive-search');
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '10');
        url.searchParams.set('resources[options][unavailable_products]', 'hide');
        searchController = new AbortController();
        productResults.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(url, { signal: searchController.signal, headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error(`Product search: ${response.status}`);
          const markup = await response.text();
          const parsed = new DOMParser().parseFromString(markup, 'text/html');
          const options = [...(parsed.querySelector('#rdr21-predictive-results')?.querySelectorAll('.rdr21-search-result') || [])]
            .filter((item) => item.dataset.productHandle && item.dataset.productId && !excludedProduct(item));
          productResults.replaceChildren(...options);
          if (!options.length) {
            const empty = document.createElement('p');
            empty.className = 'rdr21-search-empty rdr21-b2b__search-empty';
            empty.textContent = form.dataset.searchEmpty || '';
            productResults.replaceChildren(empty);
            announceSearch(empty.textContent);
          } else {
            announceSearch(`${options.length} ${form.dataset.searchPrompt || ''}`);
          }
          productResults.hidden = false;
          productInput.setAttribute('aria-expanded', 'true');
        } catch (error) {
          if (error.name !== 'AbortError') {
            productResults.replaceChildren();
            closeSuggestions();
            announceSearch(form.dataset.errorRetry || '');
          }
        } finally {
          productResults.removeAttribute('aria-busy');
        }
      };
      productInput.addEventListener('input', () => {
        window.clearTimeout(searchTimer);
        searchController?.abort();
        manuallySelectedProduct = true;
        resetSelection();
        productResults.replaceChildren();
        const term = productInput.value.trim();
        if (term.length < 2) {
          closeSuggestions();
          announceSearch('');
          return;
        }
        searchTimer = window.setTimeout(() => searchProducts(term), 220);
      });
      productInput.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' && !productResults.hidden) {
          const first = productResults.querySelector('[role="option"]');
          if (first) { event.preventDefault(); first.focus(); }
        } else if (event.key === 'Escape') {
          closeSuggestions();
        }
      });
      productResults.addEventListener('click', (event) => {
        const item = event.target.closest('.rdr21-search-result');
        if (!item) return;
        event.preventDefault();
        chooseProduct(item);
      });
      productResults.addEventListener('keydown', (event) => {
        const item = event.target.closest('.rdr21-search-result');
        if (!item) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          chooseProduct(item);
          productInput.focus();
        } else if (event.key === 'ArrowDown') {
          event.preventDefault();
          (item.nextElementSibling?.matches('.rdr21-search-result') ? item.nextElementSibling : productResults.querySelector('.rdr21-search-result'))?.focus();
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          if (item.previousElementSibling?.matches('.rdr21-search-result')) item.previousElementSibling.focus();
          else productInput.focus();
        } else if (event.key === 'Escape') {
          closeSuggestions();
          productInput.focus();
        }
      });
      document.addEventListener('click', (event) => {
        if (!form.contains(event.target)) closeSuggestions();
      });
      variantSelect.addEventListener('change', () => {
        variantIdInput.value = numericId(variantSelect.value);
        if (variantTitle) variantTitle.textContent = variantSelect.selectedOptions[0]?.textContent?.trim() || '';
      });
      if (productForm) {
        productForm.addEventListener('change', () => syncFromProductPage());
        document.addEventListener('rdr21:product-context', syncFromProductPage);
        window.addEventListener('popstate', () => syncFromProductPage());
        syncFromProductPage();
      } else {
        const initialHandle = productInput.dataset.initialProductHandle || '';
        const initialProductId = numericId(productInput.dataset.initialProductId);
        const initialVariantId = numericId(productInput.dataset.initialVariantId);
        if (initialHandle && initialProductId) {
          selectedProductHandle = initialHandle;
          productIdInput.value = initialProductId;
          loadProductVariants(initialHandle, initialProductId, initialVariantId);
        }
      }
    } else {
      syncFromProductPage();
      productForm?.addEventListener('change', syncFromProductPage);
      document.addEventListener('rdr21:product-context', syncFromProductPage);
      window.addEventListener('popstate', syncFromProductPage);
    }

    form.querySelectorAll('input,select,textarea').forEach((field) => field.addEventListener('input', () => {
      field.removeAttribute('aria-invalid');
      field.closest('.rdr21-b2b__field')?.querySelector('[data-b2b-field-error]')?.remove();
    }));

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity() || submitted) return;
      const payload = {
        request_key: '',
        customer_name: valueOf(form, 'customer_name'),
        customer_email: valueOf(form, 'customer_email'),
        company_name: valueOf(form, 'company_name'),
        country_code: valueOf(form, 'country_code'),
        vat_id: valueOf(form, 'vat_id'),
        quantity: Number(valueOf(form, 'quantity')),
        shopify_product_id: numericId(valueOf(form, 'shopify_product_id')),
        shopify_variant_id: numericId(valueOf(form, 'shopify_variant_id')),
        payment_preference: valueOf(form, 'payment_preference'),
        locale: form.dataset.b2bLocale,
        business_customer: form.elements.namedItem('business_customer')?.checked === true,
        privacy_consent: form.elements.namedItem('privacy_consent')?.checked === true,
        message: valueOf(form, 'message'),
        website: valueOf(form, 'website'),
      };
      if (!payload.shopify_product_id || !payload.shopify_variant_id) {
        setStatus(!payload.shopify_product_id ? form.dataset.productRequired : form.dataset.variantRequired, 'error');
        (productInput || productForm?.querySelector('[name="id"]'))?.focus();
        return;
      }
      const comparablePayload = JSON.stringify(payload);
      if (!requestKey || comparablePayload !== lastPayload) requestKey = makeRequestKey();
      lastPayload = comparablePayload;
      payload.request_key = requestKey;
      const originalLabel = submit.textContent;
      submitted = true;
      submit.disabled = true;
      setStatus('');
      form.querySelectorAll('[aria-invalid="true"]').forEach((field) => field.removeAttribute('aria-invalid'));
      try {
        const response = await fetch(form.dataset.endpoint, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
          signal: AbortSignal.timeout(20000),
        });
        let data = {};
        try { data = await response.json(); } catch {}
        if (response.status === 202) {
          const message = typeof data.message === 'string' && data.message.trim() ? data.message : form.dataset.successFallback;
          let finalMessage = data.reference ? `${message} (${data.reference})` : message;
          if (marketingConsent?.checked) {
            try {
              const marketingMessage = await submitNewsletterConsent(payload.customer_email);
              if (marketingMessage) finalMessage += ` ${marketingMessage}`;
            } catch {
              if (newsletterFailure) finalMessage += ` ${newsletterFailure}`;
            }
          }
          setStatus(finalMessage, 'success');
          submitted = true;
          return;
        }
        if (response.status === 404) {
          if (unavailable) { unavailable.hidden = false; unavailable.textContent = form.dataset.errorUnavailable; }
          form.hidden = true;
          return;
        }
        if (response.status === 422) {
          const errors = data.errors && typeof data.errors === 'object' ? data.errors : {};
          let firstInvalid = null;
          Object.entries(errors).forEach(([name, messages]) => {
            const field = form.elements.namedItem(name);
            if (!field || !('setAttribute' in field)) return;
            field.setAttribute('aria-invalid', 'true');
            const message = Array.isArray(messages) ? messages[0] : messages;
            if (typeof message === 'string' && field.closest('.rdr21-b2b__field')) {
              const error = document.createElement('small');
              error.dataset.b2bFieldError = '';
              error.className = 'rdr21-b2b__field-error';
              error.textContent = message;
              field.closest('.rdr21-b2b__field').append(error);
            }
            firstInvalid ||= field;
          });
          setStatus(Object.keys(errors).length ? form.dataset.errorValidation : form.dataset.errorGeneral, 'error');
          firstInvalid?.focus();
        } else if (response.status === 409) {
          requestKey = makeRequestKey();
          setStatus(form.dataset.errorGeneral, 'error');
        } else if (response.status === 429) {
          const retryAfter = Number(response.headers.get('Retry-After'));
          setStatus(retryAfter > 0 ? `${form.dataset.errorRateLimit} (${retryAfter}s)` : form.dataset.errorRateLimit, 'error');
        } else if (response.status === 503) {
          setStatus(form.dataset.errorRetry, 'error');
        } else {
          setStatus(form.dataset.errorGeneral, 'error');
        }
      } catch {
        setStatus(form.dataset.errorRetry, 'error');
      } finally {
        if (!form.hidden && status?.dataset.kind !== 'success') {
          submit.disabled = false;
          submit.textContent = originalLabel;
          submitted = false;
        }
      }
    });
  });
})();
